export const HABLEMOS_DE_TODO_LOGO_SRC =
  'https://files.tnonetwork.com/shows/logo/hablemosdetodo.png';
export const JANETH_CANO_TOP_SRC = '/images/talent/janeth-cano-top.png';
export const JANETH_CANO_BOTTOM_SRC = '/images/talent/janeth-cano-bottom.png';
